<template>
  <CustomizerWrap>
    <a
      href="#"
      class="ninjadash-customizer-btn"
      @click="
        () => {
          showCustomizer();
        }
      "
    >
      <unicon name="pen"></unicon>
      <span class="ninjadash-customizer-btn__text">Customize...</span>
    </a>
    <div
      :class="
        customizerAction
          ? 'ninjadash-customizer-wrapper show'
          : 'ninjadash-customizer-wrapper'
      "
    >
      <div class="ninjadash-customizer">
        <div class="ninjadash-customizer__head">
          <h4 class="ninjadash-customizer__title">Customizer</h4>
          <span class="ninjadash-customizer__sub-title"
            >Customize your overview Page layout</span
          >
          <a
            href="#"
            class="ninjadash-customizer-close"
            @click="
              () => {
                showCustomizer();
              }
            "
          >
            <unicon name="times"></unicon>
          </a>
        </div>
        <div class="ninjadash-customizer__body">
          <div class="ninjadash-customizer__single">
            <h4>Layout Type</h4>
            <ul class="ninjadash-customizer-list d-flex">
              <li class="ninjadash-customizer-list__item">
                <a
                  :class="!rtl ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeLayoutDirection(false);
                    }
                  "
                  href="#"
                >
                  <img :src="require('../../static/img/ltr.png')" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
              <li class="ninjadash-customizer-list__item">
                <a
                  :class="rtl ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeLayoutDirection(true);
                    }
                  "
                  href="#"
                >
                  <img :src="require(`../../static/img/rtl.png`)" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
            </ul>
          </div>
          <div class="ninjadash-customizer__single">
            <h4>Sidebar Type</h4>
            <ul class="ninjadash-customizer-list d-flex">
              <li class="ninjadash-customizer-list__item">
                <a
                  :class="!darkMode ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeLayout(false);
                    }
                  "
                  href="#"
                >
                  <img :src="require('../../static/img/light.png')" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
              <li class="ninjadash-customizer-list__item">
                <a
                  :class="darkMode ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeLayout(true);
                    }
                  "
                  href="#"
                >
                  <img :src="require(`../../static/img/dark.png`)" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
            </ul>
          </div>
          <div class="ninjadash-customizer__single">
            <h4>Navbar Type</h4>
            <ul class="ninjadash-customizer-list d-flex">
              <li class="ninjadash-customizer-list__item">
                <a
                  :class="!topMenu ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeNavbar(false);
                    }
                  "
                  href="#"
                >
                  <img :src="require('../../static/img/side.png')" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
              <li class="ninjadash-customizer-list__item top">
                <a
                  :class="topMenu ? 'active' : 'deactivate'"
                  @click="
                    () => {
                      showCustomizer();
                      changeNavbar(true);
                    }
                  "
                  href="#"
                >
                  <img :src="require(`../../static/img/top.png`)" alt="" />
                  <unicon name="check-circle"></unicon>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </CustomizerWrap>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { useStore } from "vuex";
import { CustomizerWrap } from "./style";

const Customizer = defineComponent({
  name: "Customizer",
  components: {
    CustomizerWrap,
  },
  setup() {
    const { state, dispatch } = useStore();
    const rtl = computed(() => state.themeLayout.rtlData);
    const darkMode = computed(() => state.themeLayout.data);
    const topMenu = computed(() => state.themeLayout.topMenu);
    const customizerAction = ref(false);
    const showCustomizer = () => {
      customizerAction.value = !customizerAction.value;
    };
    const changeLayout = (value) => {
      if (value) {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }
      dispatch("changeLayoutMode", value);
    };
    const changeNavbar = (value) => {
      dispatch("changeMenuMode", value);
    };
    const changeLayoutDirection = (value) => {
      const html = document.querySelector("html");
      html.setAttribute("dir", value ? "rtl" : "lrt");
      dispatch("changeRtlMode", value);
    };
    return {
      state,
      rtl,
      darkMode,
      topMenu,
      customizerAction,
      dispatch,
      showCustomizer,
      changeLayout,
      changeNavbar,
      changeLayoutDirection,
    };
  },
});

export default Customizer;
</script>
